import { ToolRoom } from '@bechtel/ht-types';
import { FC, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { appRender } from '~/components/map/app-render';
//import { MarkerProps } from '~/components/map/types';

const markerIcon = '/images/tool-room.svg';
const markerIconOnClick = '/images/toolroom-border.svg';

export interface ToolRoomMarkerProps extends google.maps.MarkerOptions {
  item?: any;
  icon?: string;
  highlightIcon?: string;
  markerPopUpComponent?: any;
  onSelect?: () => void;
  toolRoom?: ToolRoom;
  infoWindow?: google.maps.InfoWindow;
}

export const ToolRoomMarker: FC<ToolRoomMarkerProps> = (options) => {
  const [marker, setMarker] = useState<google.maps.Marker>();
  //const [infoWindow, setInfoWindow] = useState<google.maps.InfoWindow>();
  const { infoWindow } = options;

  useEffect(() => {
    if (!marker) {
      setMarker(new window.google.maps.Marker());
    }
    //Options set in constructor is not setting the marker icons, so setting options manually
    if (marker) marker.setOptions(options);
    return () => {
      if (marker) {
        marker.setMap(null);
        marker.setIcon(options.icon);
      }
    };
  }, [marker, options.icon, options.position]);

  //   useEffect(() => {
  //     if (marker) marker.setOptions(options);
  //   }, [marker, options.position]);

  useEffect(() => {
    if (marker && infoWindow) {
      marker.addListener('click', () => {
        if (options.markerPopUpComponent) {
          infoWindow.setOptions({
            content: ReactDOMServer.renderToString(appRender(options.markerPopUpComponent({ item: options.toolRoom }))),
            disableAutoPan: true,
            maxWidth: 751,
          });
          google.maps.event.addListener(infoWindow, 'closeclick', function () {
            marker?.setIcon(markerIcon);
          });
          google.maps.event.addListener(infoWindow, 'domready', function () {
            document.getElementById('reservation-button')?.addEventListener('click', () => {
              if (options.onSelect) options.onSelect();
            });
          });
        }
        if (marker.getIcon() === markerIconOnClick) {
          marker.setIcon(markerIcon);
          infoWindow.close();
          return;
        }
        marker?.setIcon(markerIconOnClick);
        infoWindow.open({
          anchor: marker,
          shouldFocus: false,
        });
      });
    }
  }, [marker, options, infoWindow]);
  return null;
};
